import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const NEW_TOWNS: Layer = {
  id: "new_towns",
  layerType: ConstraintsLayerType,
  title: "New towns 2025",
  requiredFeatureAccess: [Feature.planningPolicyLayer],
  toggleable: true,
  group: LayerGroup.STRATEGIC,
  icon: "lt-government-line",
  description: "Recommended new town locations",
  hideByDefault: true,
  label: { color: "BLUE", translationKey: "map.explore.label.new" },
  zoomConfig: {
    minVisualisationZoom: 7,
  },
  layerConfig: {
    minZoom: 7,
    rootCategory: ConstraintsCategory.NEW_TOWNS,
    categorySchema: [{ key: "new_towns" }],
  },
};
